import axios from 'axios'
import { CALL_API } from 'tr-components/redux/CallApiMiddlewareActionCreator'
import { fetchOptions } from '../../../config/endpoints'

import { sortOrder } from '../utils/sort'
import { isUUID } from '../utils/validations'

const CLEAR_SELECTED_FORM = 'forms/CLEAR_SELECTED_FORM'

const FETCH_FORM = 'forms/FETCH_FORM'
const FETCH_FORM_SUCCESS = 'forms/FETCH_FORM_SUCCESS'
const FETCH_FORM_FAIL = 'forms/FETCH_FORM_FAIL'

const FETCH_FORMS = 'forms/FETCH_FORMS'
const FETCH_FORMS_SUCCESS = 'forms/FETCH_FORMS_SUCCESS'
const FETCH_FORMS_FAIL = 'forms/FETCH_FORMS_FAIL'

const RESET_ERROR_MSG = 'forms/RESET_ERROR_MSG'
const RESET_STATE = 'forms/RESET_STATE'

const SELECT_FORM = 'forms/SELECT_FORM'
const SORT_FORMS = 'forms/SORT_FORMS'

const UPDATE_FORM = 'forms/UPDATE_FORM'
const UPDATE_FORM_SUCCESS = 'forms/UPDATE_FORM_SUCCESS'
const UPDATE_FORM_FAIL = 'forms/UPDATE_FORM_FAIL'

export const actions = {
  CLEAR_SELECTED_FORM,
  FETCH_FORM,
  FETCH_FORM_SUCCESS,
  FETCH_FORM_FAIL,
  FETCH_FORMS,
  FETCH_FORMS_SUCCESS,
  FETCH_FORMS_FAIL,
  RESET_ERROR_MSG,
  RESET_STATE,
  SELECT_FORM,
  SORT_FORMS,
  UPDATE_FORM,
  UPDATE_FORM_SUCCESS,
  UPDATE_FORM_FAIL
}

export const initialState = {
  selectedForm: null,
  errorMsg: null,
  formCount: 0,
  forms: [],
  loading: false,
  prevForms: null, // object to hold prev forms state, for optimistic update
  sortStatus: {
    index: 1,
    desc: false
  }
}

function getUpdatedForms(prevForms, newForm) {
  const newForms = prevForms.reduce((acc, form) => {
    const addForm = form.id === newForm.id ? newForm : form
    return [...acc, addForm]
  }, [])
  return {
    newForms,
    prevForms
  }
}

export default (state = initialState, action) => {
  switch (action.type) {
    case CLEAR_SELECTED_FORM:
      return {
        ...state,
        selectedForm: initialState.selectedForm
      }
    case SELECT_FORM:
      return {
        ...state,
        selectedForm: action.form
      }
    case FETCH_FORM:
      return {
        ...state,
        loading: true
      }
    case FETCH_FORM_SUCCESS:
      return {
        ...state,
        loading: false,
        selectedForm: action.payload
      }
    case FETCH_FORM_FAIL:
      return {
        ...state,
        loading: false
      }
    case FETCH_FORMS:
      return {
        ...state,
        forms: initialState.forms,
        loading: true
      }
    case FETCH_FORMS_SUCCESS:
      const res = action.payload
      const fetchedForms = Array.isArray(res) && res.length ? sortOrder(res, 'status', true) : []

      return {
        ...state,
        errorMsg: res.message ? res.message : null,
        formCount: res.length,
        forms: fetchedForms,
        loading: false
      }
    case FETCH_FORMS_FAIL:
      return {
        ...state,
        errorMsg: 'There was an error loading your forms',
        loading: false
      }
    case RESET_STATE:
      return {
        ...initialState
      }
    case RESET_ERROR_MSG:
      return {
        ...state,
        errorMsg: initialState.errorMsg
      }
    case SORT_FORMS:
      const { index, desc } = action.sortState
      const key = index === 0 ? 'title' : 'status'
      return {
        ...state,
        forms: sortOrder(state.forms, key, !desc),
        sortStatus: action.sortState
      }
    case UPDATE_FORM:
      // returns newForms and prevForms for optimistic update
      const loadingForms = getUpdatedForms(state.forms, action.payload.form)
      return {
        ...state,
        forms: loadingForms.newForms,
        prevForms: loadingForms.prevForms
      }
    case UPDATE_FORM_SUCCESS:
      // returns state from prev step and clears prevForms
      return {
        ...state,
        prevForms: null
      }
    case UPDATE_FORM_FAIL:
      // updates forms to prevForms and clears prevForms
      return {
        ...state,
        forms: state.prevForms,
        prevForms: null
      }
    default:
      return state
  }
}

export function clearSelectedForm() {
  return {
    type: CLEAR_SELECTED_FORM
  }
}

export function fetchForm(formId) {
  const apiVersion = isUUID(formId) ? 'v2' : 'v1'
  return {
    type: CALL_API,
    types: [FETCH_FORM, FETCH_FORM_SUCCESS, FETCH_FORM_FAIL],
    callAPI: () =>
      axios.get(`/forms/${formId}`, {
        ...fetchOptions(apiVersion)
      })
  }
}

export function fetchForms() {
  return {
    type: CALL_API,
    types: [FETCH_FORMS, FETCH_FORMS_SUCCESS, FETCH_FORMS_FAIL],
    callAPI: () => axios.get('/forms', { ...fetchOptions('v1') })
  }
}

export function resetErrorMsg() {
  return {
    type: RESET_ERROR_MSG
  }
}

export function resetState() {
  return {
    type: RESET_STATE
  }
}

export function selectForm(form) {
  return {
    type: SELECT_FORM,
    form
  }
}

export function sortForms(sortState) {
  return {
    type: SORT_FORMS,
    sortState
  }
}

export function updateForm(form) {
  return {
    type: CALL_API,
    types: [UPDATE_FORM, UPDATE_FORM_SUCCESS, UPDATE_FORM_FAIL],
    callAPI: () => {
      return axios.put(`/forms/${form.id}`, form, { ...fetchOptions('v1') })
    },
    payload: { form }
  }
}



// WEBPACK FOOTER //
// ./src/modules/Forms/reducers/forms.js